import type { TenantFeatures } from '@/types/auth.types';

/**
 * Gating de UI das features de PLANO opt-in (default FALSE) e dos gates de
 * feature do tenant na navegação/rotas. Mora em `lib/` (e não num arquivo de
 * componente) por causa do `react-refresh/only-export-components`.
 */

/** Subconjunto que decide Campanhas — aceita TenantFeatures e BillingPlanFeatures. */
type CampaignFeatureFlags = Pick<
  TenantFeatures,
  'whatsapp' | 'whatsapp_official_api' | 'whatsapp_campaigns'
>;

/**
 * Campanhas de WhatsApp efetivas — espelho de `Tenant.hasWhatsAppCampaigns()`:
 * módulo WhatsApp (legado, default ligado) + API oficial + feature de plano.
 * Fail-safe: as duas opt-in só liberam com `=== true`.
 */
export function hasWhatsAppCampaigns(
  f: CampaignFeatureFlags | null | undefined,
): boolean {
  return (
    f?.whatsapp !== false &&
    f?.whatsapp_official_api === true &&
    f?.whatsapp_campaigns === true
  );
}

/** Predicado OPT-IN sobre as features do tenant (mesma assinatura do SettingsNav). */
export type TenantFeatureGate = (features?: TenantFeatures) => boolean;

/**
 * Gates de tenant de um item de navegação/rota. `feature` = modelo legado
 * OPT-OUT (só bloqueia com `=== false`; keys default-true). `featureGate` =
 * predicado OPT-IN (keys default-false). Os dois presentes ⇒ AND.
 */
export function passesTenantFeatureGates(
  gates: { feature?: keyof TenantFeatures; featureGate?: TenantFeatureGate },
  features: TenantFeatures | undefined,
): boolean {
  if (gates.feature && features?.[gates.feature] === false) return false;
  if (gates.featureGate && !gates.featureGate(features)) return false;
  return true;
}
